<template>
  <section class="hero-section container-fluid" id="hp-hero">
    <img
      id="alt-logo"
      src="@/assets/csca-nav-icon.svg"
      alt="CS Capital Advisors"
    />
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 363.41 234.96"
      style="enable-background:new 0 0 363.41 234.96;"
      xml:space="preserve"
      id="csca-icon"
    >
      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1="181.7042"
        y1="25.572"
        x2="181.7042"
        y2="209.3857"
      >
        <stop offset="0" style="stop-color:#EAD37F"></stop>
        <stop offset="0.2106" style="stop-color:#E8CF7A"></stop>
        <stop offset="0.4428" style="stop-color:#E1C56D"></stop>
        <stop offset="0.6853" style="stop-color:#D6B357"></stop>
        <stop offset="0.9335" style="stop-color:#C79B39"></stop>
        <stop offset="1" style="stop-color:#C2932F"></stop>
      </linearGradient>
      <g id="Layer_1">
        <path
          :class="{ 'stroke-style': true, 'long-lines': animateSVG }"
          d="M185.31,56.13c1.12-1.1,2.76-2.66,4.82-4.43c6.07-5.19,27.04-23.26,58.65-24c6.55-0.15,35.77-0.11,61.02,22.28
		c4.74,4.2,27.76,25.53,29.65,60.65c1.74,32.45-15.46,59.68-35.47,74.86c-6.14,4.66-22.27,15.56-44.62,17.46
		c-3.48,0.3-14.48,1-28.16-2.22c-10.22-2.41-17.59-5.99-20.4-7.43c-11.5-5.9-18.53-12.9-26.6-21.06
		c-16.22-16.41-24.34-24.61-39.9-41.24c-6.57-7.02-7.56-7.95-12.89-13.45c-3.6-3.71-7.69-7.96-15.82-16.48
		c-7.82-8.2-25.8-27.21-49.55-52.54"
        ></path>
        <path
          :class="{ 'stroke-style': true, 'long-lines': animateSVG }"
          d="M179.3,175.86c-1.12,1.1-2.76,2.66-4.82,4.43c-6.07,5.19-27.04,23.26-58.65,24
		c-6.55,0.15-35.77,0.11-61.02-22.28c-4.74-4.2-27.76-25.53-29.65-60.65C23.41,88.91,40.62,61.68,60.62,46.5
		c6.14-4.66,22.27-15.56,44.62-17.46c3.48-0.3,14.48-1,28.16,2.22c10.22,2.41,17.59,5.99,20.4,7.43c11.5,5.9,18.53,12.9,26.6,21.06
		c16.22,16.41,24.34,24.61,39.9,41.24c6.57,7.02,7.56,7.95,12.89,13.45c3.6,3.71,7.69,7.96,15.82,16.48
		c7.82,8.2,25.8,27.21,49.55,52.54"
        ></path>
        <path
          :class="{ 'stroke-style': true, 'short-lines': animateSVG }"
          d="M119.71,114.16c-22.06,19.69-44.12,39.39-66.18,59.08"
        ></path>
        <path
          :class="{ 'stroke-style': true, 'short-lines': animateSVG }"
          d="M244.74,118.54c22.06-19.69,44.12-39.39,66.18-59.08"
        ></path>
      </g>
    </svg>
    <img
      id="csca-logotype"
      src="@/assets/csca-logotype.svg"
      alt="CS Capital Advisors"
    />
    <div class="logo-underline-container">
      <div id="logo-underline"></div>
    </div>
    <h2 class="subhead white-text text-center" id="logo-tag">
      Financial Advisory &amp; Asset Management
    </h2>
    <a
      id="explore-link"
      class="btn -hollow_white mt-6"
      href="#intro"
      @click.prevent="scrollLink"
      >Explore</a
    >
  </section>
</template>

<script>
import { gsap, TweenLite, TimelineLite, Power2 } from "gsap";
// eslint-disable-next-line no-unused-vars
import ScrollToPlugin from "gsap/dist/ScrollToPlugin";
export default {
  data() {
    return {
      animateSVG: false,
      isMS: false
    };
  },
  methods: {
    scrollLink() {
      const scrollPlugin = ScrollToPlugin;
      var target = document.getElementById("intro").offsetTop;
      gsap.to(window, {
        duration: 1,
        scrollTo: target,
        ease: 'power2.out'
      });
    },
    animateHero() {
      var component = this;
      var t1 = new TimelineLite({ paused: true });
      var logoType = document.getElementById("csca-logotype"),
        logoUnderline = document.getElementById("logo-underline"),
        logoTag = document.getElementById("logo-tag"),
        exploreLink = document.getElementById("explore-link");
      t1.add(TweenLite.to(logoType, 2, { opacity: 1, ease: Power2.easeOut }));
      t1.add(
        TweenLite.to(logoUnderline, 2, {
          width: "100%",
          left: 0,
          ease: Power2.easeOut
        }),
        "-=1"
      );
      t1.add(
        TweenLite.to(logoTag, 2, { opacity: 1, ease: Power2.ease }),
        "-=2"
      );
      t1.add(
        TweenLite.to(exploreLink, 1, {
          opacity: 1,
          ease: Power2.easeOut
        }),
        "-=1"
      );
      if (!this.isMS) {
        setTimeout(function() {
          component.animateSVG = true;
        }, 750);
        t1.delay(2.65).play();
      } else {
        var altLogo = document.getElementById("alt-logo");
        TweenLite.to(altLogo, 1, { opacity: 1 });
        t1.delay(1).play();
      }
      this.isLoaded = true;
    }
  },
  created() {
    if (
      navigator.userAgent.indexOf("Edge") >= 0 ||
      navigator.userAgent.indexOf("Trident/") >= 0
    ) {
      this.isMS = true;
    }
  },
  mounted() {
    gsap.registerPlugin(ScrollToPlugin)
    if (this.isMS) {
      document.getElementById("csca-icon").style.display = "none";
      document.getElementById("alt-logo").classList.add("ms-vis");
      var altLogo = document.getElementById("alt-logo");
      TweenLite.set(altLogo, { opacity: 0 });
    }
    if (this.$parent.$parent.isLoaded) {
      if (this.isMS) {
        TweenLite.to(altLogo, 1, { opacity: 1 });
      } else {
        this.animateSVG = true;
      }
      var logoType = document.getElementById("csca-logotype"),
        logoUnderline = document.getElementById("logo-underline"),
        logoTag = document.getElementById("logo-tag"),
        exploreLink = document.getElementById("explore-link");
      logoType.style.opacity = "1";
      logoUnderline.style.width = "100%";
      logoTag.style.opacity = "1";
      exploreLink.style.opacity = "1";
    } else {
      this.animateHero();
    }
  }
};
</script>

<style lang="scss" scoped>
#hp-hero {
  height: 100vh;
  min-height: 700px;
  background-color:  #111d3c;
  background-image: url(../assets/hp-hero-bg.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: -100px;
  @media screen and (max-width: 350px) {
    min-height: 500px;
  }
}
#alt-logo {
  display: none;
  height: 0;
  width: 0;
  &.ms-vis {
    display: block;
    height: 80px;
    width: auto;
  }
}
#csca-icon {
  width: 150px;
  @media screen and (max-width: 768px) {
    width: 100px;
  }
}
#csca-logotype {
  width: 800px;
  max-width: 90%;
  margin-top: 2rem;
  opacity: 0;
}
.logo-underline-container {
  width: 600px;
  max-width: 80%;
  margin: 2rem auto;
  display: flex;
  justify-content: center;
}
#logo-underline {
  height: 2px;
  width: 0;
  background-color: #dcb249;
}
#logo-tag {
  opacity: 0;
}

#explore-link {
  opacity: 0;
}

h2.subhead {
  font-size: 1.5rem;
}
.stroke-style {
  fill: none;
  stroke-width: 12.5px;
  stroke: url(#SVGID_1_);
  stroke-miterlimit: 10;
  stroke-dasharray: 890;
  stroke-dashoffset: 890;
}
.long-lines {
  animation: dash 1.7s ease-in-out forwards;
}
.short-lines {
  animation: 1.5s dash 1s ease-in-out forwards;
}
@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
